import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { Button, ImageUploader } from "components";

import { ReactComponent as InfoIcon } from "icons/info.svg";
import {
  updateCourseImage,
  deleteCourseImage,
} from "actions/courses";

const Image = ({
  course,
  change,
  pristine,
  handleSubmit,
  updateCourseImage,
  deleteCourseImage,
}) => {
  const has_image = Boolean(course.image_url);

  const onSubmit = ({ image }) =>
    updateCourseImage(course.id, image);

  return (
    <div className="dashboard">
      <header className="dashboard__header">
        <div className="icon__container">
          <InfoIcon />
        </div>
        <h2 className="dashboard__title heading">
          Miniaturka
        </h2>
        {has_image ? (
          <Button
            type="delete"
            text="Usuń"
            onClick={() => deleteCourseImage(course.id)}
          />
        ) : (
          <Button
            type="save"
            disabled={pristine}
            text="Zapisz"
            onClick={handleSubmit(onSubmit)}
          />
        )}
      </header>
      <div className="dashboard__image">
        {has_image ? (
          <img src={course.image_url} alt="" />
        ) : (
          <ImageUploader
            handleFile={(file) => change("image", file)}
          />
        )}
      </div>
    </div>
  );
};

export default connect(
  ({ course }) => ({
    course: course.data,
    initialValues: {
      image: null,
    },
  }),
  (dispatch) => ({
    updateCourseImage: (id, image) =>
      dispatch(updateCourseImage(id, image)),
    deleteCourseImage: (id) =>
      dispatch(deleteCourseImage(id)),
  })
)(
  reduxForm({
    form: "course_edit_image",
    enableReinitialize: true,
  })(Image)
);
